import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
var BaseBreadcrumbs = function (props) {
    var listBreadcrumb = props.listBreadcrumb;
    return (_jsx(Breadcrumbs, { "aria-label": 'breadcrumb', children: listBreadcrumb.map(function (item, index) {
            return item.isLink ? (_jsxs(Link, { to: item.href || '', className: 'flex gap-1 items-center', children: [item.icon, item.label] }, "".concat(item.label, "_").concat(index))) : (_jsxs(Typography, { onClick: item.callBackFn, className: 'flex gap-1 items-center', children: [item.icon, item.label] }, index));
        }) }));
};
export default BaseBreadcrumbs;
